import { z } from 'zod'

/** 點數及可兌換禮遇數量 Schema */
export const pointAndCourtesySchema = z.object({
  /** 合約日期起 */
  contractStartTime: z.string(),
  /** 合約日期迄 */
  contractEndTime: z.string(),
  /** 可兌換點數 */
  point: z.number(),
  /** 可兌換禮遇數量 */
  courtesyCount: z.number()
})

/** 點數及可兌換禮遇數量 */
export interface PointAndCourtesy
  extends z.infer<typeof pointAndCourtesySchema> {}

export class PointAndCourtesy {
  constructor() {
    return {
      contractStartTime: '',
      contractEndTime: '',
      point: 0,
      courtesyCount: 0
    }
  }
}
